import styled from 'styled-components'
import { Form } from 'antd'

const AntFormStyled = styled(Form)`
  .has-error {
    font-style: italic;
    color: #cc0033;
  }
  &&& .ant-form-explain {
    min-height: 15px;
  }
`
export default AntFormStyled
